import { render, staticRenderFns } from "./UiTimeago.vue?vue&type=template&id=9e653b98"
import script from "./UiTimeago.vue?vue&type=script&lang=js"
export * from "./UiTimeago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports